import { SET_SCAN_CLAIM } from './types';

const initialState = {
  scanClaim: '',
};

export const scanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SCAN_CLAIM:
      return { ...state, scanClaim: action.payload };
    default:
      return state;
  }
};
